import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShowMore from "@Shared/components/general/show-more";
import TablePagination from "@Shared/components/general/table-pagination";
import SegmentSubscribedButton from "./segment-subscribed-button";
import { mapGetters } from "vuex";
import { GET_SEGMENTS_TRANSLATION_MAP } from "@Broker/@Modules/marketing/store/marketing/marketing-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsTable",
  components: {
    SegmentSubscribedButton,
    TablePagination,
    ShowMore
  },
  props: {
    listId: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    emailCount: {
      type: Number,
      required: true
    },
    offset: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    },
    orderBy: {
      type: String,
      default: "updatedAt"
    },
    orderType: {
      type: String,
      default: "DESC"
    }
  },
  data() {
    return {
      segmentData: {
        name: "",
        join: "or",
        conditions: [{
          id: 1,
          operator: "=",
          values: [{
            id: 1,
            value: ""
          }]
        }]
      },
      segmentJoin: "",
      segmentName: "",
      columns: ["email", "source", "firstname", "lastname", "appstatus", "profilestatus", "value", "renewaldate", "referrer", "phoneNumber", "coApps", "referralCode", "referrerType", "referrerCombinedValue", "numberOfClients", "optin"]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("MarketingStore", [GET_SEGMENTS_TRANSLATION_MAP])), {}, {
    currentListLength() {
      return this.list.length;
    },
    options() {
      return {
        filterable: false,
        headings: {
          email: this.$tc("account.email", 1),
          source: this.$tc("global.words.source", 1),
          firstname: this.$t("account.givenName"),
          lastname: this.$t("account.familyName"),
          appstatus: this.$t("lists.segments.appStatus"),
          profilestatus: this.$t("lists.segments.profileStatus"),
          value: this.$t("global.words.value"),
          renewaldate: this.$t("global.doorr.renewalDate"),
          referrer: this.$tc("global.doorr.referrer", 1),
          phoneNumber: this.$t("account.phoneNumber"),
          coApps: this.$tc("global.doorr.coapplicant", 2),
          referralCode: this.$t("global.doorr.referralCode"),
          referrerType: this.$t("global.doorr.referralType"),
          referrerCombinedValue: this.$t("global.doorr.combinedValue"),
          numberOfClients: this.$t("global.doorr.numberOfClients"),
          optin: this.$t("lists.segments.optin")
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        sortable: ["email", "source", "firstname", "lastname", "appstatus", "profilestatus", "value", "renewaldate", "referrer", "phoneNumber", "referralCode", "referrerType", "referrerCombinedValue", "numberOfClients", "optin"],
        orderBy: {
          column: this.orderBy,
          ascending: this.orderType === "ASC" ? true : false
        },
        customSorting: {
          email: ascending => this.handleSorting("email", ascending),
          source: ascending => this.handleSorting("source", ascending),
          firstname: ascending => this.handleSorting("firstname", ascending),
          lastname: ascending => this.handleSorting("lastname", ascending),
          appstatus: ascending => this.handleSorting("appstatus", ascending),
          profilestatus: ascending => this.handleSorting("profilestatus", ascending),
          value: ascending => this.handleSorting("value", ascending),
          renewaldate: ascending => this.handleSorting("renewaldate", ascending),
          referrer: ascending => this.handleSorting("referrer", ascending),
          phoneNumber: ascending => this.handleSorting("phoneNumber", ascending),
          referralCode: ascending => this.handleSorting("referralCode", ascending),
          referrerType: ascending => this.handleSorting("referrerType", ascending),
          referrerCombinedValue: ascending => this.handleSorting("referrerCombinedValue", ascending),
          numberOfClients: ascending => this.handleSorting("numberOfClients", ascending),
          optin: ascending => this.handleSorting("optin", ascending)
        },
        perPage: 10,
        tabbable: false,
        columnsClasses: {
          fullname: "w-25",
          email: "w-25"
        },
        skin: "table table-hover",
        texts: {
          noResults: this.$t("lists.segments.noSegments")
        }
      };
    }
  }),
  methods: {
    getCombined(row) {
      return _parseInt(row.referrerCombinedValue);
    },
    handlePageChange({
      offset
    }) {
      this.$emit("page-change", offset);
    },
    handleSubscribe() {
      this.$emit("subscribe");
    },
    formatMoneyValue(value) {
      return value && value !== "0" ? this.$options.filters.formatMoneyValue(value) : "";
    },
    getSourceText(source) {
      return this.$t("lists.source")[source] || source;
    },
    getTranslatedApplicationStatus(applicationStatus) {
      return this.GET_SEGMENTS_TRANSLATION_MAP(applicationStatus) || applicationStatus;
    },
    coApplicantsText(coApplicants) {
      var _coApplicants$map$joi;
      return (_coApplicants$map$joi = coApplicants == null ? void 0 : _mapInstanceProperty(coApplicants).call(coApplicants, coapp => `${coapp.givenName || ""} ${coapp.familyName || ""}`).join(",")) != null ? _coApplicants$map$joi : "";
    },
    handleSorting(sortBy, ascending) {
      if (sortBy !== this.orderBy || ascending && this.orderType === "DESC" || !ascending && this.orderType === "ASC") {
        this.$emit("sort-list", {
          orderBy: sortBy,
          orderType: ascending ? "ASC" : "DESC"
        });
      }
    }
  }
});